import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { AppReview, getAppClient } from '@/api/app-client'

export const APP_QUERY_IDS = {
  REVIEWS: ['app', 'reviews'] as const
}

/**
 * Fetches reviews of all statuses; filtering by status happens client-side
 * (the review table's status index can be stale for records that were edited
 * directly in DynamoDB, so the UI filters on the actual attribute).
 */
export const useQueryListAppReviews = () => {
  return useQuery<AppReview[]>({
    queryKey: APP_QUERY_IDS.REVIEWS,
    queryFn: () => getAppClient().listReviews(),
    refetchOnWindowFocus: true
  })
}

const useInvalidateAppReviews = () => {
  const queryClient = useQueryClient()

  return () =>
    queryClient.invalidateQueries({
      queryKey: ['app', 'reviews']
    })
}

export const useMutationApproveAppReview = () => {
  const invalidate = useInvalidateAppReviews()

  return useMutation<
    void,
    unknown,
    { appId: string; version: string; orgId: string }
  >({
    mutationFn: (params) => getAppClient().approveReview(params),
    onSuccess: invalidate
  })
}

export const useMutationRejectAppReview = () => {
  const invalidate = useInvalidateAppReviews()

  return useMutation<
    void,
    unknown,
    { appId: string; version: string; orgId: string }
  >({
    mutationFn: (params) => getAppClient().rejectReview(params),
    onSuccess: invalidate
  })
}
